import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

export const profissionaisRotas = (): RouteRecordRaw[] => [
  {
    path: "/profissionais",
    name: "Profissionais",
    meta: {
      titulo: t("tituloDaRotaDeProfissionais"),
      regras: ["auth", "cancelador"],
      modulo: "Profissionais",
      operador: "ou",
      permissoes: ["criar:ambos", "visualizar:outros"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Profissionais" */
        "@/paginas/Profissionais/ListaDeProfissionais/ListaDeProfissionais.vue"
      ),
  },
  {
    path: "/profissionais/novo-profissional",
    name: "CriarProfissional",
    props: true,
    meta: {
      titulo: t("tituloDaRotaDeCriarProfissional"),
      regras: ["auth", "cancelador"],
      modulo: "Profissionais",
      operador: "e",
      permissoes: ["visualizar:outros"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Profissionais" */
        "@/paginas/Profissionais/NovoProfissional/NovoProfissional.vue"
      ),
  },
  {
    path: "/profissionais/editar-profissional/:id",
    name: "EditarProfissional",
    props: true,
    meta: {
      titulo: t("tituloDaRotaDeEditarProfissional"),
      regras: ["auth", "cancelador"],
      modulo: "Profissionais",
      operador: "e",
      permissoes: ["visualizar:outros"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Profissionais" */
        "@/paginas/Profissionais/NovoProfissional/NovoProfissional.vue"
      ),
  },
]
